module.exports = __webpack_public_path__ + "5ab195b4e6e504c599788428f592a828.png";